export default {
  // 消息中心
  path: '/message',
  component: resolve => require(['@/views/main.vue'], resolve),
  children: [{
    path: '',
    component: resolve => require(['@/views/home/message/index.vue'], resolve)
  }]
}